// Components==============
import { faCloudUpload, faFolderPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import updateGroup from 'actions/group/update';
import Button from 'components/UI/Button';
import SearchBar from 'components/UI/SearchBar';
import React, { useContext, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { GroupContext } from 'screens/Group';
import AddNewFolderModal from '../Explorer/components/Modals/AddNewFolderModal';
import './index.module.scss';
// =========================

export default function Top() {
    const { searchValue, setSearchValue, group } = useContext(GroupContext);

    const [addNewFolderModalIsOpen, setAddNewFolderModalIsOpen] = useState(
        false
    );

    const dispatch = useDispatch();

    const labelRef = useRef();

    const handleChange = (e) => {
        dispatch(
            updateGroup({
                groupId: group.id,
                file: e.target.files[0],
            })
        );
    };

    return (
        <>
            <div styleName="wrapper">
                <SearchBar
                    dashboard
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                />
                <input
                    type="file"
                    id="btn"
                    onChange={handleChange}
                    name="upload"
                    styleName="file-input"
                />
                <label htmlFor="btn" ref={labelRef}>
                    <Button
                        color="#1e265c"
                        background="#ffffff"
                        onClick={() => labelRef.current.click()}
                    >
                        <FontAwesomeIcon icon={faCloudUpload} /> Uploaden
                    </Button>
                </label>
                <Button
                    color="#1e265c"
                    background="#ffffff"
                    onClick={() => setAddNewFolderModalIsOpen(true)}
                >
                    <FontAwesomeIcon icon={faFolderPlus} /> Nieuwe map
                </Button>
            </div>

            {addNewFolderModalIsOpen && (
                <AddNewFolderModal
                    setModalIsOpen={setAddNewFolderModalIsOpen}
                />
            )}
        </>
    );
}
